import { gql } from "@/services/httpAdapter";
import { TechnicianPerformanceFragment } from "../../fragments/technicianPerformanceFragment";

// Common Fragments
import {
	AddedCompensationFragment,
	CompensationFragment,
	EmployeeFragment,
	LongevityFragment,
	ReviewFragment,
	TechnicianSpiffsFragment,
} from "@/Washouts/api/common/fragments";

export function getOnCreateTechniciansWashout() {
	return gql`
		subscription onNewTechniciansWashoutAvailable($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onNewTechniciansWashoutAvailable(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				userId
				commissionCycleId
				payPeriodId
				created
				employee {
					...Employee
				}
				flaggedTimePerformance {
					...TechnicianPerformance
				}
				pendingRepairOrders {
					...TechnicianPerformance
				}
				spiffs {
					...Spiffs
				}
				longevity {
					...Longevity
				}
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${TechnicianPerformanceFragment}
		${AddedCompensationFragment}
		${CompensationFragment}
		${EmployeeFragment}
		${LongevityFragment}
		${ReviewFragment}
		${TechnicianSpiffsFragment}
	`;
}

export const getOnUpdateTechniciansWashout = () => {
	return gql`
		subscription onUpdateTechniciansWashout($commissionCycleId: String, $payPeriodId: String, $userId: String) {
			onUpdateTechniciansWashout(commissionCycleId: $commissionCycleId, payPeriodId: $payPeriodId, userId: $userId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				review {
					...Review
				}
				addedCompensations {
					...AddedCompensation
				}
				summary {
					...Compensation
				}
			}
		}
		${AddedCompensationFragment}
		${CompensationFragment}
		${ReviewFragment}
	`;
};

export function getOnUpdateTechniciansWashoutStatus() {
	return gql`
		subscription onUpdateTechniciansWashoutStatus($commissionCycleId: String) {
			onUpdateTechniciansWashoutStatus(commissionCycleId: $commissionCycleId) {
				_id
				commissionCycleId
				payPeriodId
				userId
				position
				status
				employee {
					position
				}
				review {
					...Review
				}
			}
		}
		${ReviewFragment}
	`;
}
